export default {
    CompanyID: {
        JCG: {
            ID: 1,
            AccessRight: "bankingdetailsaudit_johnchapleygroup"   
        },
        SBD: {
            ID: 2,
            AccessRight: "bankingdetailsaudit_sbd"   
        },
        CRG: {
            ID: 3,
            AccessRight: "bankingdetailsaudit_crg"   
        },
        CG: {
            ID: 4,
            AccessRight: "bankingdetailsaudit_cg"   
        }
    }
}